<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content fluid>
      <HeaderSimple />
      <v-row class="align-center justify-center login pa-4 ma-0">
        <v-col class="col-12 col-sm-9 col-md-6 col-lg-4">
          <ComponentLogin v-on:data="saveData" />
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import HeaderSimple from "../../components/HeaderSimple";
import ComponentLogin from "../../components/ComponentLogin";

export default {
  data() {
    return {
      snackbar: false,
      msg: "",
    };
  },
  components: {
    HeaderSimple,
    ComponentLogin,
  },

  methods: {
    saveData(res) {
      if (res.isLogged) {
        this.$router.replace("/psicologo");
      } else {
        this.snackbar = true;
        this.msg = res.msg;
      }
    },
  },
};
</script>
